/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/stopwatch_medium'
export default icon
